import React from 'react'
import { Link } from 'react-router-dom'
import image from '../../assets/images/Leadership/image5.jpg'
const COO = () => {
  return (
    <div className="container py-lg-5 py-md-4 py-3">
            <div className="row">
                <div className="col-lg-6 col-md-6 d-flex align-items-center">
                    <img className='img-fluid' src={image} alt="Amit Gaur" />
                </div>
                <div className="col-lg-6 col-md-6 ">
                <div className="ceo">
                    <h6>Leadership</h6>
                    <h1 className='fw-bold mb-3'>Amit Gaur </h1>
                    <h4>Administartive Director | TechTorch Solutions</h4>
                    <div className='social-media'>
                    {/* <Link  className='link'><i className="bi bi-twitter-x"></i></Link> */}
                    <Link to="https://www.linkedin.com/in/amit-gaur-4754a278/" className='link'><i className="bi bi-linkedin"></i></Link>
                   
                    </div>
                   <p>
    Amit Gaur brings TechTorch Solutions a wealth of operational and administrative expertise, built on over ten years of experience in networking and database management. As Administrative Director and Board Member, he plays a key role in optimizing daily operations, fostering cross-organizational collaboration, and ensuring that the company’s resources are effectively managed.
</p>
<p>
    Amit ensures that everyday operations run seamlessly and that business activities align with the company's strategic goals. His leadership style emphasizes accountability, creating an environment where taking responsibility for decisions and actions drives growth, efficiency, and success across the organization.
</p>


                </div>
                </div>
            </div>
        </div>
  )
}

export default COO
